module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-chalk-2-3fd58af15c9dee895dfb860be45716bd.webp";